import './TagsMainMenu.scss';
import { AMPLITUDE_PERISCOPE_EVENT_SOURCE } from '@sonar-software/sonar-analytics';
import { DarkTheme } from '@ui/themes';
import { haltClickEventPropagation } from '@lib/events';
import { Link } from 'react-router-dom';
import { Row } from 'antd';
import { SearchInput } from '@ui/general';
import { SettingOutlined } from '@ant-design/icons';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarTagDisplay } from '@ui/tags';
import { COPY_SONAR_OBJECT_BASE_PLURAL, FULL_ROUTES, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useMemo, useState } from 'react';
import { useApplicationSidebar, useCurrentUser, usePeriscopeActions, useTags } from '@hooks';
function buildSubMenuItem(tags, isReadOnly, isCollapsed, handleTagClick, handleSearchChange, filterValue) {
    var _a, _b;
    const topLabel = isReadOnly ?
        COPY_SONAR_OBJECT_BASE_PLURAL.TAG :
        React.createElement(Row, { justify: 'space-between' },
            COPY_SONAR_OBJECT_BASE_PLURAL.TAG,
            isCollapsed ?
                React.createElement(SettingOutlined, null) :
                React.createElement(Link, { className: 'manager-link', onClick: haltClickEventPropagation, to: FULL_ROUTES.TAGS_MANAGE },
                    React.createElement(SettingOutlined, null)));
    const subMenuItem = {
        children: isCollapsed ? undefined : [],
        className: 'tag-submenu',
        key: FULL_ROUTES.TAGS_MANAGE,
        label: topLabel,
        route: isCollapsed ? FULL_ROUTES.TAGS_MANAGE : undefined
    };
    if (!isCollapsed && (tags === null || tags === void 0 ? void 0 : tags.length) > 10) {
        (_a = subMenuItem.children) === null || _a === void 0 ? void 0 : _a.push({
            className: 'tag-search-entry',
            key: 'tag-search',
            label: React.createElement(DarkTheme, null,
                React.createElement("div", { id: 'tag-search' },
                    React.createElement(SearchInput, { className: 'tag-search-input', onChange: handleSearchChange, placeholder: PLACEHOLDERS_COPY.SEARCH_TAGS })))
        });
    }
    if (!isCollapsed) {
        const matchesFilter = (tag) => {
            if (!filterValue) {
                return true;
            }
            return tag.name.toLowerCase().includes(filterValue.toLowerCase());
        };
        for (const tag of tags.filter(matchesFilter)) {
            (_b = subMenuItem.children) === null || _b === void 0 ? void 0 : _b.push({
                className: 'tag-submenu-item',
                id: `tag-${tag.id}`,
                key: `tag-${tag.id}`,
                label: React.createElement(SonarTagDisplay, { noBorder: true, tagId: tag.id }),
                onClick: () => handleTagClick(tag)
            });
        }
    }
    return subMenuItem;
}
export function useTagSubMenu() {
    const { isClosed } = useApplicationSidebar();
    const [filterValue, setFilterValue] = useState('');
    const tags = useTags();
    const { startPeriscope } = usePeriscopeActions();
    const { isReadOnly } = useCurrentUser();
    const handleTagClick = useCallback((tag) => {
        startPeriscope({
            from: AMPLITUDE_PERISCOPE_EVENT_SOURCE.MAIN_MENU,
            id: tag.id,
            name: tag.name,
            type: SonarObjectType.SonarTag
        });
    }, [startPeriscope]);
    const subMenu = useMemo(() => buildSubMenuItem(tags, isReadOnly, isClosed, handleTagClick, setFilterValue, filterValue), [filterValue, handleTagClick, isClosed, isReadOnly, tags]);
    return subMenu;
}
